module.exports = __webpack_public_path__ + "d55c8ebe340b9932aa4e5d6cc1383974.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/sofas/sofa-winter.png
// module id = 3431
// module chunks = 0